import GLApi from './_glApi';
import httpClient from '@/apis/base/httpclient';

class GLVoucherListAPI extends GLApi {
  constructor() {
    super();
  }
  controllerName = 'GLVoucherLists';
  // Custom hàm xóa => trả về cảnh báo trước
  //lttuan1 - 15.9.2022
  async customDelete(payload) {
    let request = {
      url: this.getAPIUrl() + '/CustomDelete',
      data: payload,
    };

    return await httpClient.deleteAsync(request);
  }
}

export default new GLVoucherListAPI();
